<template>
	<header :class="classes">
		<div class="segment">
			<slot name="left">
				<MobileMenuIcon
					@click="onMobileClicked"
				/>
			</slot>
		</div>
		<div class="segment">
			<h1>
				<slot name="title"></slot>
			</h1>
		</div>
		<div class="segment">
			<slot name="right"></slot>
		</div>
	</header>
</template>

<script>
import MobileMenuIcon from "../components/icons/MobileMenuIcon";

/**
 * PageHeaderLayout
 *
 * Layout for a full page header component, divided into three slots:
 * - left
 * - title
 * - right
 *
 * Applies mobile styles at mobile breakpoints to center title at mobile resolutions.
 */
export default {
	name: "PageHeaderLayout",
	emits: [ "menu", ],
	components: {
		MobileMenuIcon,
	},
	props: {
		showBorder: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		classes() {
			return {
				"page-header-layout": true,
				"page-header-layout--bordered": this.showBorder,
			};
		},
	},
	methods: {
		onMobileClicked( e ) {
			e.preventDefault();
			e.stopPropagation();
			this.$foundation().sidebar.open();
		},
	},
};
</script>

<style lang="scss" scoped>
$page-header-layout-title-color: $color1-700;
$page-header-layout-border-color: $color1-200;

.page-header-layout {
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	padding: 1rem;

	h1 {
		@include font-and-line-for(2);
		color: $page-header-layout-title-color;
		font-weight: 700;
	}

	@include for-size('md') {
		padding: 2rem;
	}
}

.page-header-layout--bordered {
	border-bottom: 0.0625rem solid $page-header-layout-border-color;
}

.page-header-layout > .segment {
	display: flex;
	align-items: center;
	flex: 1;

	// align the mobile icon left
	&:first-of-type {
		justify-content: flex-start;
	}

	// align the title center
	&:nth-of-type(2) {
		justify-content: center;
		flex: 2;
	}

	// align the button right
	&:last-of-type {
		justify-content: flex-end;
	}

	@include for-size('md') {
		// hide the mobile icon
		&:first-of-type {
			display: none;
		}

		// align the title left
		&:nth-of-type(2) {
			justify-content: flex-start;
		}
	}
}
</style>
